import type { RootStateOrAny } from 'react-redux'
import type { Dispatch } from 'redux'

import { actionTypes } from 'actions/actionTypes'
import { trackOrder } from 'actions/order'
import { orderConfirmationRedirect } from 'actions/orderConfirmation'
import statusActions from 'actions/status'
import { getAccessToken, getAuthUserId, getIsAuthenticated } from 'selectors/auth'

import { createOrder } from '../apis/orderV2'
import { getSlotForBoxSummaryDeliveryDays, getOrderV2 } from '../selectors/order'

const { pending, error } = statusActions

export const checkoutTransactionalOrder =
  () => async (dispatch: Dispatch<any>, getState: () => RootStateOrAny) => {
    const state = getState()
    if (!getIsAuthenticated(state)) {
      return
    }

    const userId = getAuthUserId(state)
    const [slot, slotId] = getSlotForBoxSummaryDeliveryDays(state)

    if (!slot) {
      dispatch(pending(actionTypes.ORDER_SAVE, false))
      dispatch(error(actionTypes.ORDER_SAVE, `Can't find any slot with id: ${slotId}`))

      return
    }

    dispatch(statusActions.error(actionTypes.ORDER_SAVE, null))
    dispatch(statusActions.pending(actionTypes.ORDER_SAVE, true))

    // todo is this check really needed? it doesn't stop the flow in v1...
    // const couldBasketBeExpired = getCouldBasketBeExpired(getState())

    const accessToken = getAccessToken(state)
    const orderRequest = getOrderV2(state)

    try {
      const order = await createOrder(accessToken, orderRequest, userId)
      dispatch(trackOrder('create', order))
      dispatch(orderConfirmationRedirect(order.id, 'create'))
      dispatch(statusActions.pending(actionTypes.ORDER_SAVE, false))
    } catch (e: any) {
      const { message, code } = e
      dispatch(error(actionTypes.ORDER_SAVE, { message, code }))
    }
  }
